import { IPayoutSettingsResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorInstantPayoutDefaultFee } from "../selectors/selectorInstantPayoutDefaultFee";

class InstantPayoutService {
  calculateInvoiceInstantPayoutFee(
    amount: number,
    payoutSettings?: IPayoutSettingsResponse
  ) {
    const instantPayoutDefaultFee =
      selectorInstantPayoutDefaultFee(payoutSettings);
    const instantPayoutDefaultFeeMultiplier = instantPayoutDefaultFee / 100;

    const instantPayoutFee = amount * instantPayoutDefaultFeeMultiplier;

    // Prevent setting 0.5 if the fee amount is 0
    if (instantPayoutFee === 0) {
      return 0;
    }

    if (instantPayoutFee < 0.5) {
      return 0.5;
    }

    return instantPayoutFee;
  }
}

export const instantPayoutService = new InstantPayoutService();
